import Vue from 'vue'
import Router from 'vue-router'

import Company from '@/pages/company_page'
import Offer from '@/pages/offer_page'
import Service from '@/pages/service_page'

import Navbar from '@/components/navbar'
import About from '@/components/companyPage/company_about'
import Team from '@/components/companyPage/company_team'
import WhyUs from '@/components/companyPage/company_whyus'
import Partners from '@/components/companyPage/company_partners'

import OfferMain from '@/components/offerPage/main_offer'
import SalesPoint from '@/components/offerPage/sales_point'
import Screenshots from '@/components/offerPage/screenshots'
import Store from '@/components/offerPage/store'
import Advantages from '@/components/offerPage/advantages'
import StepsGetStarted from '@/components/offerPage/steps_get_started'

import FeatureService from '@/components/servicePage/featureservice'
import OperationModel from '@/components/servicePage/operationmodel'
import Technologic from '@/components/servicePage/technologic'

import Faq from '@/pages/faq_page'
import FaqInfo from '@/components/faqPage/faqinfo'

import Feature from '@/components/feature'
// import Screenshots from '@/components/screenshots'
import LatestBlog from '@/components/latest_blog'
import Price from '@/components/price'
import Testimonial from '@/components/testimonial'
import Feedbacks from '@/components/offerPage/feedback'
import ContactUs from '@/components/contact_us'
import Subscribe from '@/components/subscribe'
import RecallForm from '@/components/recallForm'


import Map from '@/components/map'
import Tile from '@/components/tile'
import Footer from '@/components/footer'
import PageNotFound from '@/components/pagenotfound'
import js from '@/components/js'

import Signin from '@/pages/sign_in'
import Signup from '@/pages/sign_up'
import ForgetPassword from '@/pages/forget_Password'
import Review from '@/pages/review'
import Thankyou from '@/pages/thank_you'
import download from '@/pages/download'
import comingsoon from '@/pages/coming_soon'
import Emailtemplate from '@/pages/email_template'
import color from '@/components/color'


Vue.use(Router)
Vue.component('Navbar', Navbar)
Vue.component('About', About)
Vue.component('Offer', Offer)
Vue.component('Service', Service)
Vue.component('Team', Team)
Vue.component('WhyUs', WhyUs)
Vue.component('Partners', Partners)
Vue.component('Company', Company)

Vue.component('OfferMain', OfferMain)
Vue.component('SalesPoint', SalesPoint)
Vue.component('Screenshots', Screenshots)
Vue.component('Store', Store)
Vue.component('Advantages', Advantages)
Vue.component('StepsGetStarted', StepsGetStarted)
Vue.component('FeatureService', FeatureService)
Vue.component('OperationModel', OperationModel)
Vue.component('Technologic', Technologic)

Vue.component('Faq', Faq)
Vue.component('FaqInfo', FaqInfo)

Vue.component('Feature', Feature)


Vue.component('Price', Price)
Vue.component('Testimonial', Testimonial)
Vue.component('Feedback', Feedbacks)
Vue.component('Contact_us', ContactUs)
Vue.component('Subscribe', Subscribe)
Vue.component('RecallForm', RecallForm)
Vue.component('Map', Map)
Vue.component('Footer', Footer)
Vue.component('Signin', Signin)
Vue.component('Signup', Signup)
Vue.component('ForgetPassword', ForgetPassword)
Vue.component('Thankyou', Thankyou)
Vue.component('Review', Review)
Vue.component('download', download)
Vue.component('comingsoon', comingsoon)
Vue.component('Emailtemplate', Emailtemplate)
Vue.component('js', js)
Vue.component('Tile', Tile)
Vue.component('color', color)

export default new Router({
  // Hash mode works on IIS without the optional URL Rewrite module.
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {path: '/', redirect: '/offer'},
    {
      path: '/offer',
      name: 'Offer',
      components: {
        default: Offer,
        navbar: Navbar
      }
    },
    {
      path: '/company',
      name: 'Company',
      components: {
        default: Company,
        navbar: Navbar
      }
    },
    {
      path: '/service',
      name: 'Service',
      components: {
        default: Service,
        navbar: Navbar
      }
    },
    {
      path: '/faq',
      name: 'Faq',
      components: {
        default: Faq,
        navbar: Navbar
      }
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/404',
      name: 'pagenotfound',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js